import { gql } from '@apollo/client';

export const GetDocumentLink = gql`
  query GetDocumentLink($documentId: String!, $ediType: EDIType!) {
    getDocumentLink(documentId: $documentId, ediType: $ediType) @rest(path: "/Documents?{args}", method: "GET") {
      data
      errors {
        ...Error
      }
    }
  }
`;
